import React, { useState } from "react";
import { PatientParticulars } from "./PatientParticulars";

const RelationshipStatus = [
  "Married",
  "Partnered",
  "Single",
  "Divorced",
  "Separated",
  "Widowed",
];

export const SocialHistory = ({
  setPatientMedicationInfo,
  patientMedicationInfo,
}) => {
  const [socialHistoryInfo, setSocialHistoryInfo] = useState({
    relationshipStatus: "",
    stairsInHouse: "",
  });
  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setPatientMedicationInfo({
      ...patientMedicationInfo,
      [name]: value,
    });
  };
  return (
    <div className="mb-6 flex flex-col bg-white p-5 shadow-sm rounded">
      <div className="flex flex-col gap-8 mb-4  shadowsForMainWrappe border-b border-[#d4d4d4]  p-6 py-10">
        <div>
          <h3 className="font-mainFont font-[600] 2xl:text-[1.5vw] xl:text-[1.5vw] lg:text-[1.5vw] md:text-[1.5vw] text-[4.5vw] text-[#333333]">
            Relationship Status
          </h3>
        </div>
        <div className="flex gap-4 flex-wrap justify-start w-full">
          {RelationshipStatus.map((item, id) => (
            <button
              type="button"
              onClick={() => {
                setPatientMedicationInfo({
                  ...patientMedicationInfo,
                  relationshipStatus: item.trim(), // Trim to remove any trailing spaces
                });
              }}
              key={id}
              className={`text-[#333333]   px-8 py-1 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-mainFont font-[500] rounded-full  transition-all duration-200 ease-linear shadowsForMainWrapper ${
                patientMedicationInfo.relationshipStatus === item.trim()
                  ? "text-[#fff] BTNGradientBg"
                  : "text-black bg-white"
              }`}
            >
              {item}
            </button>
          ))}
        </div>
      </div>

      <div className="flex flex-col 2xl:flex-row xl:flex-row lg:flex-row md:flex-col justify-between  gap-8 my-4">
        <div className="flex-1 flex flex-col gap-5">
          <div className="flex flex-col justify-start items-start gap-3 w-full">
            <label className="text-[#333333] font-[600] 2xl:text-[1.2dvw] xl:text-[1.2dvw] lg:text-[1.2dvw] md:text-[1.2dvw] text-[3.5vw]">
              Number of Children, if any
            </label>
            <input
              type="number"
              className=" w-full px-6 py-3 rounded-full border outline-none border-[#d4d4d4] font-mainFont font-[500] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] placeholder:text-[#333333]/50 text-mainColor bg-[#f0f0f0]"
              placeholder="Enter Number"
              name="NoOfChildrens"
              value={patientMedicationInfo?.NoOfChildrens}
              onChange={handleOnChange}
            />
          </div>
          <div className=" flex justify-start items-center gap-5 w-full">
            <div className="flex flex-col justify-start items-start gap-3 w-full">
              <label className="text-[#333333] font-[600] 2xl:text-[1.2dvw] xl:text-[1.2dvw] lg:text-[1.2dvw] md:text-[1.2dvw] text-[3.5vw]">
                Occupation
              </label>
              <input
                type="text"
                className=" w-full px-6 py-3 rounded-full border outline-none border-[#d4d4d4] font-mainFont font-[500] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] placeholder:text-[#333333]/50 text-mainColor bg-[#f0f0f0]"
                placeholder="Enter Occupation"
                name="occupation"
                value={PatientParticulars?.occupation}
                onChange={handleOnChange}
              />
            </div>
          </div>
          <div className=" flex  justify-start items-center gap-5 w-full">
            <div className="flex flex-col justify-start items-start gap-3 w-full">
              <label className="text-[#333333] font-[600] 2xl:text-[1.2dvw] xl:text-[1.2dvw] lg:text-[1.2dvw] md:text-[1.2dvw] text-[3.5vw]">
                When was the last time you worked?
              </label>
              <input
                type="text"
                className=" w-full px-6 py-3 rounded-full border outline-none border-[#d4d4d4] font-mainFont font-[500] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] placeholder:text-[#333333]/50 text-mainColor bg-[#f0f0f0]"
                placeholder="Enter last working year"
                name="lastTimeWorked"
                value={patientMedicationInfo?.lastTimeWorked}
                onChange={handleOnChange}
              />
            </div>
          </div>
          <div className=" flex  justify-start items-center gap-5 w-full">
            <div className="flex flex-col justify-start items-start gap-3 w-full">
              <label className="text-[#333333] font-[600] 2xl:text-[1.2dvw] xl:text-[1.2dvw] lg:text-[1.2dvw] md:text-[1.2dvw] text-[3.5vw]">
                Who is in your current household?
              </label>
              <input
                type="text"
                className=" w-full px-6 py-3 rounded-full border outline-none border-[#d4d4d4] font-mainFont font-[500] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] placeholder:text-[#333333]/50 text-mainColor bg-[#f0f0f0]"
                placeholder="Enter current household"
                onChange={handleOnChange}
                name="currentHousehold"
                value={patientMedicationInfo?.currentHousehold}
              />
            </div>
          </div>
        </div>
        <div className="flex-1">
          <div className=" flex  justify-start items-center gap-5 w-full p-6  border border-[#d4d4d4]">
            <div className="flex flex-col justify-center items-center gap-3 w-full">
              <label className=" font-[600]  2xl:text-[1.2dvw] xl:text-[1.2dvw] lg:text-[1.2dvw] md:text-[1.2dvw] text-[3.5vw] text-[#333333]">
                Are there any stairs in your current home?
              </label>
              <div className="flex justify-start items-center gap-4">
                <button
                  type="button"
                  onClick={() => {
                    setPatientMedicationInfo({
                      ...patientMedicationInfo,
                      stairsInHouse: "Yes",
                    });
                  }}
                  className={`text-[#333333]   px-8 py-1 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-mainFont font-[500] rounded-full  transition-all duration-200 ease-linear shadowsForMainWrapper ${
                    patientMedicationInfo.stairsInHouse === "Yes"
                      ? "text-[#fff] BTNGradientBg"
                      : "text-black bg-white"
                  }`}
                >
                  Yes
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setPatientMedicationInfo({
                      ...patientMedicationInfo,
                      stairsInHouse: "No",
                    });
                  }}
                  className={`text-[#333333]   px-8 py-1 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-mainFont font-[500] rounded-full  transition-all duration-200 ease-linear shadowsForMainWrapper ${
                    patientMedicationInfo.stairsInHouse === "No"
                      ? "text-[#fff] BTNGradientBg"
                      : "text-black bg-white"
                  }`}
                >
                  No
                </button>
              </div>
            </div>
          </div>
          <div className="grid 2xl:grid-cols-2 xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-1 gap-5 my-10 w-full">
            <div className="flex flex-col justify-start gap-4 border border-[#d4d4d4]  p-5">
              <h3 className="font-mainFont font-[600] 2xl:text-[1.2dvw] xl:text-[1.2dvw] lg:text-[1.2dvw] md:text-[1.2dvw] text-[3.5vw] text-[#333333] mb-2">
                Employment / Disability
              </h3>
              <div className="flex justify-between items-center">
                <div>
                  <label>Temporary Disability</label>
                </div>
                <div>
                  <input
                    type="radio"
                    name="employmentDisability"
                    value="Temporary Disability"
                    checked={patientMedicationInfo?.employmentDisability === "Temporary Disability"}
                    onChange={handleOnChange}
                  />
                </div>
              </div>
              <div className="flex justify-between items-center">
                <div>
                  <label>Permanent Disability</label>
                </div>
                <div>
                  <input
                    type="radio"
                    name="employmentDisability"
                    value="Permanent Disability"
                    checked={patientMedicationInfo?.employmentDisability === "Permanent Disability"}
                    onChange={handleOnChange}
                  />
                </div>
              </div>
              <div className="flex justify-between items-center">
                <div>
                  <label>Retired</label>
                </div>
                <div>
                  <input
                    type="radio"
                    name="employmentDisability"
                    value="Retired"
                    checked={patientMedicationInfo?.employmentDisability === "Retired"}
                    onChange={handleOnChange}
                  />
                </div>
              </div>
              <div className="flex justify-between items-center">
                <div>
                  <label>Unemployed</label>
                </div>
                <div>
                  <input
                    type="radio"
                    name="employmentDisability"
                    value="Unemployed"
                    checked={patientMedicationInfo?.employmentDisability === "Unemployed"}
                    onChange={handleOnChange}
                  />
                </div>
              </div>
            </div>
            <div>
              <div className="flex flex-col justify-start items-start gap-3 w-full">
                <label className="text-[#333333] font-[600] 2xl:text-[1.2dvw] xl:text-[1.2dvw] lg:text-[1.2dvw] md:text-[1.2dvw] text-[3.5vw]">
                  Date Started
                </label>
                <input
                  type="date"
                  name="employmentDisabilityDateStarted"
                  className=" w-full px-6 py-3 rounded-full border outline-none border-[#d4d4d4] font-mainFont font-[500] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] placeholder:text-[#333333]/50 text-mainColor bg-[#f0f0f0]"
                  value={patientMedicationInfo?.employmentDisabilityDateStarted || ""}
                  onChange={handleOnChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Alcohol Use Section */}
      <div className="flex flex-col gap-8 mb-4 shadowsForMainWrappe border-b border-[#d4d4d4] p-6 py-10">
        <div>
          <h3 className="font-mainFont font-[600] 2xl:text-[1.5vw] xl:text-[1.5vw] lg:text-[1.5vw] md:text-[1.5vw] text-[4.5vw] text-[#333333]">
            Alcohol Use
          </h3>
        </div>
        <div className="flex gap-4 flex-wrap justify-start w-full">
          {["Daily use of alcohol", "Social use", "History of Alcoholism", "Current Alcoholism", "Never"].map((item, id) => (
            <button
              onClick={() => {
                setPatientMedicationInfo({
                  ...patientMedicationInfo,
                  alcoholUse: item,
                });
              }}
              key={id}
              className={`text-[#333333] px-8 py-1 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-mainFont font-[500] rounded-full transition-all duration-200 ease-linear shadowsForMainWrapper ${
                patientMedicationInfo?.alcoholUse === item
                  ? "text-[#fff] BTNGradientBg"
                  : "text-black bg-white"
              }`}
            >
              {item}
            </button>
          ))}
        </div>
      </div>

      {/* Tobacco Use Section */}
      <div className="flex flex-col gap-8 mb-4 shadowsForMainWrappe border-b border-[#d4d4d4] p-6 py-10">
        <div>
          <h3 className="font-mainFont font-[600] 2xl:text-[1.5vw] xl:text-[1.5vw] lg:text-[1.5vw] md:text-[1.5vw] text-[4.5vw] text-[#333333]">
            Tobacco Use
          </h3>
        </div>
        <div className="flex gap-4 flex-wrap justify-start w-full mb-6">
          {["Current User", "Former User", "Never used"].map((item, id) => (
            <button
              onClick={() => {
                setPatientMedicationInfo({
                  ...patientMedicationInfo,
                  tobaccoUse: item,
                  // Clear follow-up fields if "Never used" is selected
                  ...(item === "Never used" ? {
                    tobaccoUseYears: "",
                    tobaccoUsePacksPerDay: "",
                    tobaccoUseQuitDate: "",
                  } : {}),
                });
              }}
              key={id}
              className={`text-[#333333] px-8 py-1 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-mainFont font-[500] rounded-full transition-all duration-200 ease-linear shadowsForMainWrapper ${
                patientMedicationInfo?.tobaccoUse === item
                  ? "text-[#fff] BTNGradientBg"
                  : "text-black bg-white"
              }`}
            >
              {item}
            </button>
          ))}
        </div>
        {(patientMedicationInfo?.tobaccoUse === "Current User" || patientMedicationInfo?.tobaccoUse === "Former User") && (
          <div className="grid 2xl:grid-cols-3 xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-1 gap-5">
            <div className="flex flex-col justify-start items-start gap-3">
              <label className="text-[#333333] font-[600] 2xl:text-[1.2dvw] xl:text-[1.2dvw] lg:text-[1.2dvw] md:text-[1.2dvw] text-[3.5vw]">
                How many years?
              </label>
              <input
                type="text"
                name="tobaccoUseYears"
                className="w-full px-6 py-3 rounded-full border outline-none border-[#d4d4d4] font-mainFont font-[500] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] placeholder:text-[#333333]/50 text-mainColor bg-[#f0f0f0]"
                placeholder="Enter years"
                value={patientMedicationInfo?.tobaccoUseYears || ""}
                onChange={handleOnChange}
              />
            </div>
            <div className="flex flex-col justify-start items-start gap-3">
              <label className="text-[#333333] font-[600] 2xl:text-[1.2dvw] xl:text-[1.2dvw] lg:text-[1.2dvw] md:text-[1.2dvw] text-[3.5vw]">
                Packs per day?
              </label>
              <input
                type="text"
                name="tobaccoUsePacksPerDay"
                className="w-full px-6 py-3 rounded-full border outline-none border-[#d4d4d4] font-mainFont font-[500] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] placeholder:text-[#333333]/50 text-mainColor bg-[#f0f0f0]"
                placeholder="Enter packs per day"
                value={patientMedicationInfo?.tobaccoUsePacksPerDay || ""}
                onChange={handleOnChange}
              />
            </div>
            {patientMedicationInfo?.tobaccoUse === "Former User" && (
              <div className="flex flex-col justify-start items-start gap-3">
                <label className="text-[#333333] font-[600] 2xl:text-[1.2dvw] xl:text-[1.2dvw] lg:text-[1.2dvw] md:text-[1.2dvw] text-[3.5vw]">
                  Quit Date?
                </label>
                <input
                  type="date"
                  name="tobaccoUseQuitDate"
                  className="w-full px-6 py-3 rounded-full border outline-none border-[#d4d4d4] font-mainFont font-[500] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] placeholder:text-[#333333]/50 text-mainColor bg-[#f0f0f0]"
                  value={patientMedicationInfo?.tobaccoUseQuitDate || ""}
                  onChange={handleOnChange}
                />
              </div>
            )}
          </div>
        )}
      </div>

      {/* Illegal Drug Use Section */}
      <div className="flex flex-col gap-8 mb-4 shadowsForMainWrappe border-b border-[#d4d4d4] p-6 py-10">
        <div>
          <h3 className="font-mainFont font-[600] 2xl:text-[1.5vw] xl:text-[1.5vw] lg:text-[1.5vw] md:text-[1.5vw] text-[4.5vw] text-[#333333]">
            Illegal Drug Use
          </h3>
        </div>
        <div className="flex gap-4 flex-wrap justify-start w-full mb-6">
          {["Denies any illegal drug use", "Currently uses illegal drugs", "Formerly used illegal drugs"].map((item, id) => (
            <button
              onClick={() => {
                setPatientMedicationInfo({
                  ...patientMedicationInfo,
                  illegalDrugUse: item,
                  // Clear text field if "Denies any illegal drug use" is selected
                  ...(item === "Denies any illegal drug use" ? {
                    illegalDrugUseDetails: "",
                  } : {}),
                });
              }}
              key={id}
              className={`text-[#333333] px-8 py-1 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-mainFont font-[500] rounded-full transition-all duration-200 ease-linear shadowsForMainWrapper ${
                patientMedicationInfo?.illegalDrugUse === item
                  ? "text-[#fff] BTNGradientBg"
                  : "text-black bg-white"
              }`}
            >
              {item}
            </button>
          ))}
        </div>
        {(patientMedicationInfo?.illegalDrugUse === "Currently uses illegal drugs" || patientMedicationInfo?.illegalDrugUse === "Formerly used illegal drugs") && (
          <div className="flex flex-col justify-start items-start gap-3 w-full">
            <label className="text-[#333333] font-[600] 2xl:text-[1.2dvw] xl:text-[1.2dvw] lg:text-[1.2dvw] md:text-[1.2dvw] text-[3.5vw]">
              If yes, what drug(s)?
            </label>
            <textarea
              name="illegalDrugUseDetails"
              className="w-full px-6 py-3 rounded-lg border outline-none border-[#d4d4d4] font-mainFont font-[500] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] placeholder:text-[#333333]/50 text-mainColor bg-[#f0f0f0] min-h-[100px] resize-y"
              placeholder="Enter drug(s) name(s)"
              value={patientMedicationInfo?.illegalDrugUseDetails || ""}
              onChange={handleOnChange}
            />
          </div>
        )}
      </div>

      {/* Prescription / Narcotic Use Section */}
      <div className="flex flex-col gap-8 mb-4 shadowsForMainWrappe border-b border-[#d4d4d4] p-6 py-10">
        <div>
          <h3 className="font-mainFont font-[600] 2xl:text-[1.5vw] xl:text-[1.5vw] lg:text-[1.5vw] md:text-[1.5vw] text-[4.5vw] text-[#333333]">
            Prescription / Narcotic Use
          </h3>
        </div>
        <p className="font-mainFont font-[600] 2xl:text-[1.1vw] xl:text-[1.1vw] lg:text-[1.1vw] md:text-[2.3vw] text-[3.5vw] text-[#333333]">
          Have you ever abused narcotic or prescription medications?
        </p>
        <div className="flex justify-start items-center gap-4">
          <button
            onClick={() => {
              setPatientMedicationInfo({
                ...patientMedicationInfo,
                prescriptionNarcoticAbuse: "Yes",
              });
            }}
            className={`text-[#333333] ${
              patientMedicationInfo?.prescriptionNarcoticAbuse === "Yes"
                ? "text-[#fff] BTNGradientBg"
                : "text-black bg-white"
            }  px-8 py-1 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-mainFont font-[500] rounded-full  transition-all duration-200 ease-linear shadowsForMainWrapper`}
          >
            Yes
          </button>
          <button
            onClick={() => {
              setPatientMedicationInfo({
                ...patientMedicationInfo,
                prescriptionNarcoticAbuse: "No",
              });
            }}
            className={`text-[#333333]   px-8 py-1 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-mainFont font-[500] rounded-full  transition-all duration-200 ease-linear shadowsForMainWrapper ${
              patientMedicationInfo?.prescriptionNarcoticAbuse === "No"
                ? "text-[#fff] BTNGradientBg"
                : "text-black bg-white"
            }`}
          >
            No
          </button>
        </div>
      </div>

      {/* Transfusion / Graft History Section */}
      <div className="flex flex-col gap-8 mb-4 shadowsForMainWrappe border-b border-[#d4d4d4] p-6 py-10">
        <div>
          <h3 className="font-mainFont font-[600] 2xl:text-[1.5vw] xl:text-[1.5vw] lg:text-[1.5vw] md:text-[1.5vw] text-[4.5vw] text-[#333333]">
            Transfusion / Graft History
          </h3>
        </div>
        <div className="flex flex-col gap-4">
          {["Blood transfusion", "Use of bone grafts", "Use of donated organ tissue"].map((item, id) => (
            <div key={id} className="flex justify-start items-center gap-3">
              <input
                name="transfusionGraftHistory"
                type="checkbox"
                id={`transfusionGraft_${id}`}
                value={item}
                onChange={(e) => {
                  const currentValue = patientMedicationInfo.transfusionGraftHistory || [];
                  const currentArray = Array.isArray(currentValue) ? currentValue : [];
                  const isChecked = currentArray.includes(item);
                  
                  setPatientMedicationInfo({
                    ...patientMedicationInfo,
                    transfusionGraftHistory: isChecked
                      ? currentArray.filter((i) => i !== item)
                      : [...currentArray, item],
                  });
                }}
                checked={Array.isArray(patientMedicationInfo?.transfusionGraftHistory) 
                  ? patientMedicationInfo.transfusionGraftHistory.includes(item) 
                  : false}
              />
              <label
                htmlFor={`transfusionGraft_${id}`}
                className="font-mainFont font-[400] text-[#333333] 2xl:text-[1.2vw] xl:text-[1.2vw] lg:text-[1.2vw] md:text-[2.3vw] text-[3.5vw]"
              >
                {item}
              </label>
            </div>
          ))}
        </div>
      </div>

      {/* Family History Section */}
      <div className="flex flex-col gap-8 mb-4 shadowsForMainWrappe border-b border-[#d4d4d4] p-6 py-10">
        <div>
          <h3 className="font-mainFont font-[600] 2xl:text-[1.5vw] xl:text-[1.5vw] lg:text-[1.5vw] md:text-[1.5vw] text-[4.5vw] text-[#333333]">
            Family History
          </h3>
        </div>
        <div className="flex flex-col gap-4">
          {["Arthritis", "Rheumatoid Arthritis", "Cancer", "Diabetes", "High Blood Pressure", "Kidney Problems", "Liver Problems", "Seizures", "Stroke", "Osteoporosis", "Headaches/Migraines", "I have no significant family medical history."].map((item, id) => (
            <div key={id} className="flex justify-start items-center gap-3">
              <input
                name="familyHistory"
                type="checkbox"
                id={`familyHistory_${id}`}
                value={item}
                onChange={(e) => {
                  const currentValue = patientMedicationInfo.familyHistory || [];
                  const currentArray = Array.isArray(currentValue) ? currentValue : [];
                  const isChecked = currentArray.includes(item);
                  
                  setPatientMedicationInfo({
                    ...patientMedicationInfo,
                    familyHistory: isChecked
                      ? currentArray.filter((i) => i !== item)
                      : [...currentArray, item],
                    // Clear "Other Medical Problems" text if "I have no significant family medical history." is selected
                    ...(item === "I have no significant family medical history." && !isChecked ? {
                      familyHistoryOtherText: "",
                    } : {}),
                  });
                }}
                checked={Array.isArray(patientMedicationInfo?.familyHistory) 
                  ? patientMedicationInfo.familyHistory.includes(item) 
                  : false}
              />
              <label
                htmlFor={`familyHistory_${id}`}
                className="font-mainFont font-[400] text-[#333333] 2xl:text-[1.2vw] xl:text-[1.2vw] lg:text-[1.2vw] md:text-[2.3vw] text-[3.5vw]"
              >
                {item}
              </label>
            </div>
          ))}
          <div className="flex justify-start items-center gap-3">
            <input
              name="familyHistory"
              type="checkbox"
              id="familyHistory_Other"
              value="Other Medical Problems"
              onChange={(e) => {
                const currentValue = patientMedicationInfo.familyHistory || [];
                const currentArray = Array.isArray(currentValue) ? currentValue : [];
                const isChecked = currentArray.includes("Other Medical Problems");
                
                setPatientMedicationInfo({
                  ...patientMedicationInfo,
                  familyHistory: isChecked
                    ? currentArray.filter((i) => i !== "Other Medical Problems")
                    : [...currentArray, "Other Medical Problems"],
                  // Clear text if unchecking
                  ...(isChecked ? {
                    familyHistoryOtherText: "",
                  } : {}),
                });
              }}
              checked={Array.isArray(patientMedicationInfo?.familyHistory) 
                ? patientMedicationInfo.familyHistory.includes("Other Medical Problems") 
                : false}
            />
            <label
              htmlFor="familyHistory_Other"
              className="font-mainFont font-[400] text-[#333333] 2xl:text-[1.2vw] xl:text-[1.2vw] lg:text-[1.2vw] md:text-[2.3vw] text-[3.5vw]"
            >
              Other Medical Problems
            </label>
          </div>
          {Array.isArray(patientMedicationInfo?.familyHistory) && patientMedicationInfo.familyHistory.includes("Other Medical Problems") && (
            <div className="flex flex-col justify-start items-start gap-3 w-full mt-2">
              <label className="text-[#333333] font-[600] 2xl:text-[1.2dvw] xl:text-[1.2dvw] lg:text-[1.2dvw] md:text-[1.2dvw] text-[3.5vw]">
                Please specify:
              </label>
              <textarea
                name="familyHistoryOtherText"
                className="w-full px-6 py-3 rounded-lg border outline-none border-[#d4d4d4] font-mainFont font-[500] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] placeholder:text-[#333333]/50 text-mainColor bg-[#f0f0f0] min-h-[100px] resize-y"
                placeholder="Enter other medical problems"
                value={patientMedicationInfo?.familyHistoryOtherText || ""}
                onChange={handleOnChange}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
